import { useState } from 'react'
import { bindOperation, changeOpenId, autoChangeOpenId, getAgencyInfoList, getAccountInfo } from '../utils/network'
import showAlert from 'utils/showAlert'
import { searchAMS } from 'utils/searchAMSInfo'
import { OPERATION_ERROR_CODE, SERVER_RES, ACCOUNT_TYPE_OF_BINDING } from '../contants'
import { cgiCallWrapper, errorProcess } from 'utils/cgiCallWrapper'
import showConfirmAlert from 'utils/showConfirmAlert'
import { OPERATION_AD_TYPE, ACCOUNT_TYPE } from '../../OperationList/constants'

const initialSubmitInfo = {
    type: 0, // 广告类型
    ids: '', // 广告账户ID
    selectAccount: 0, // 账户类型
    showInput: false,
    serviceProviderId: '',
}

const useOperationBind = props => {
    const { appInfo, onClose, updateList } = props
    const [submitInfo, setSubmitInfo] = useState(initialSubmitInfo)
    const [error, setError] = useState('')
    const [disableSubmit, setDisableSubmit] = useState(false)

    const setType = val => {
        setSubmitInfo({
            ...submitInfo,
            type: val,
        })
    }

    const setAccount = val => {
        setSubmitInfo({
            ...submitInfo,
            selectAccount: val,
            showInput: val === 1,
        })
    }

    const setServiceProviderId = val => {
        setSubmitInfo({
            ...submitInfo,
            serviceProviderId: val,
        })
    }

    const setIds = val => {
        setSubmitInfo({
            ...submitInfo,
            ids: val,
        })
    }

    const reset = () => {
        setSubmitInfo(initialSubmitInfo)
    }

    const successProcess = () => {
        showAlert('success', '绑定账号提交成功')
        onClose()
        // 更新列表数据
        updateList()
        reset()
    }
    const getIds = arr => {
        if (arr.length > 0) {
            return arr.map(v => v.uid).join(',')
        }
        return ''
    }

    const handleChangeBind = async uids => {
        try {
            await showConfirmAlert('primary', `账号${uids.join(',')}已被其他用户绑定，是否继续申请绑定`, {
                cancelButton: true,
                backdrop: true,
            })
            const uidInfos = await validateAccountType()
            if (!uidInfos) return
            // 要新绑定的数据
            const newParams = {
                appid: appInfo.appId,
                ...submitInfo,
                uidInfos: [],
            }
            // 要换绑的数据
            const bindedParams = {
                appid: appInfo.appId,
                ...submitInfo,
                uidInfos: [],
            }
            if (Number(submitInfo.type) === ACCOUNT_TYPE_OF_BINDING.TX_ADVERTISING_DELIVERY) {
                uidInfos.forEach(item => {
                    if (uids.map(v => Number(v)).includes(Number(item.uid))) {
                        bindedParams.uidInfos.push(item)
                    } else {
                        newParams.uidInfos.push(item)
                    }
                })
                bindedParams.ids = await getIds(bindedParams.uidInfos)
                newParams.ids = await getIds(newParams.uidInfos)
            } else {
                bindedParams.uidInfos = uidInfos
            }
            const res = await cgiCallWrapper(
                Number(submitInfo.type) === ACCOUNT_TYPE_OF_BINDING.TX_ADVERTISING_DELIVERY
                    ? autoChangeOpenId
                    : changeOpenId,
                bindedParams
            )

            if (res.c !== SERVER_RES.SUCCESS) return
            const bindOperationRes = await cgiCallWrapper(bindOperation, newParams, false)
            if (bindOperationRes.c !== SERVER_RES.SUCCESS) return
            successProcess()
        } catch (_) {
            showAlert('error', '程序错误，请联系客服')
            setDisableSubmit(false)
        }
    }

    const getCheckErrorMsg = () => {
        if (!submitInfo.type) {
            return '请选择绑定类型'
        }
        if (!submitInfo.selectAccount) {
            return '请选择投放账户类型'
        }
        if (!submitInfo.serviceProviderId && submitInfo.selectAccount === ACCOUNT_TYPE.SERVICE_PROVIDER) {
            return '请输入服务商id'
        }
        if (submitInfo.serviceProviderId) {
            if (!/^\d+$/.test(`${submitInfo.serviceProviderId}`)) {
                return '投放账户类型中的服务商id必须是纯数字，且只能填写单个服务商id'
            }
        }

        if (!submitInfo.ids) {
            return '请填写账户ID'
        }
        if (submitInfo.type === OPERATION_AD_TYPE.KA) {
            if (!/^\d+$/.test(`${submitInfo.ids}`)) {
                return '应用宝代理绑定类型账户ID格式必须为纯数字，且只能填写单个账户'
            }
            return
        }
        submitInfo.ids = submitInfo.ids.replace(/[!|@|%|*|,|\/|+|-|，]/g, ',')
        if (submitInfo.ids.split(',').length > 20) return '腾讯广告投放类型账户单次批量提交不可大于20条'

        const ids = submitInfo.ids.split(',')
        if (ids.length !== new Set(ids).size) return '填写内容中有重复账户ID，请核准后再提交'
        return ''
    }

    const validateForm = () => {
        const errorMsg = getCheckErrorMsg()
        setError(errorMsg)
        if (errorMsg) return false
        return true
    }

    const validateAccountType = async () => {
        try {
            const uids = []
            // 投放帐户类型——服务商
            if (submitInfo.selectAccount === ACCOUNT_TYPE.SERVICE_PROVIDER) {
                setDisableSubmit(true)
                const serviceInfo = await searchAMS({
                    serviceProviderId: submitInfo.serviceProviderId,
                    getAccountInfo: getAccountInfo,
                })
                if (!serviceInfo) {
                    setDisableSubmit(false)
                    return
                }
                // 子客信息
                const agencyRes = await cgiCallWrapper(
                    getAgencyInfoList,
                    {
                        agency_id: submitInfo.serviceProviderId,
                        account_ids: submitInfo.ids.split(','),
                        account_type: 1,
                        advertiser_type: 2,
                        size: 200,
                    },
                    false
                )
                setDisableSubmit(false)
                if (agencyRes.code === 0) {
                    const agencyList = agencyRes.data.list.map(item => {
                        return {
                            uid: String(item.account_id),
                            uidName: item.nick_name,
                            uidCategory: item.attribution_department || '',
                            serviceInfo,
                        }
                    })
                    if (agencyList.length === 0) {
                        showAlert('error', '该服务商下没有子客')
                        setDisableSubmit(false)
                        return
                    }
                    const accountUids = agencyList.length > 0 ? agencyList.map(item => Number(item.uid)) : []
                    const newIds = submitInfo.ids.split(',')
                    const oldIds = []
                    newIds.forEach(id => {
                        if (Number(id) !== 0 && !accountUids.includes(Number(id))) {
                            oldIds.push(id)
                        } else {
                            uids.push(agencyList.find(v => Number(v.uid) === Number(id)))
                        }
                    })
                    if (oldIds.length > 0) {
                        showAlert('error', `投入账户ID:${oldIds.join(',')},不在服务商${serviceInfo.serviceID}名下`)
                        setDisableSubmit(false)
                        return
                    }
                }
                if (agencyRes.code !== 0) {
                    showAlert('error', '程序错误，请联系客服')
                    setDisableSubmit(false)
                    return
                }
            }

            // 投放帐户类型——直客
            if (submitInfo.selectAccount === ACCOUNT_TYPE.DIRECT) {
                setDisableSubmit(true)
                // 得到服务商信息
                const agencyRes = await cgiCallWrapper(
                    getAgencyInfoList,
                    {
                        account_ids: submitInfo.ids.split(','),
                        size: 200,
                        account_type: 1,
                        advertiser_type: 1,
                    },
                    false
                )
                setDisableSubmit(false)

                if (agencyRes.code === 0) {
                    if (agencyRes.data.list.length > 0) {
                        const agencyList = agencyRes.data.list.map(item => {
                            return {
                                uid: String(item.account_id),
                                uidName: item.nick_name,
                                uidCategory: item.attribution_department || '',
                            }
                        })
                        const accountUids = agencyList.length > 0 ? agencyList.map(item => Number(item.uid)) : []
                        const oldIds = []
                        submitInfo.ids.split(',').forEach(id => {
                            if (Number(id) !== 0 && !accountUids.includes(Number(id))) {
                                oldIds.push(id)
                            } else {
                                uids.push(agencyList.find(v => Number(v.uid) === Number(id)))
                            }
                        })
                        if (oldIds.length > 0) {
                            showAlert('error', `${oldIds.join(',')}子客不存在`)
                            setDisableSubmit(false)
                            return
                        }
                    }
                    if (agencyRes.data.list.length < 1) {
                        showAlert('error', '直客投放帐户下不存在该帐户id')
                        setDisableSubmit(false)
                        return
                    }
                }
                if (agencyRes.code !== 0) {
                    showAlert('error', '程序错误，请联系客服')
                    setDisableSubmit(false)
                    return
                }
            }
            return uids
        } catch (_) {
            showAlert('error', '程序错误，请联系客服')
            setDisableSubmit(false)
            return
        }
    }

    const handleSubmit = async e => {
        e.preventDefault()
        try {
            if (!validateForm()) return
            const uidInfos = await validateAccountType()
            if (!uidInfos) return
            setDisableSubmit(true)
            const res = await cgiCallWrapper(
                bindOperation,
                {
                    appid: appInfo.appId,
                    ...submitInfo,
                    uidInfos,
                },
                false
            )
            setDisableSubmit(false)

            // 账号绑定重复，需要更换为当前的OPENID
            if (res.c === OPERATION_ERROR_CODE.UID_BIND_EXIST) {
                handleChangeBind(res.d)
                return
            }

            if (res.c !== SERVER_RES.SUCCESS) {
                errorProcess(res)
                return
            }
            successProcess()
        } catch (_) {
            showAlert('error', '程序错误，请联系客服')
            setDisableSubmit(false)
        }
    }
    return {
        handleSubmit,
        disableSubmit,
        setDisableSubmit,
        submitInfo,
        setType,
        setAccount,
        setServiceProviderId,
        setIds,
        reset,
        error,
    }
}

export default useOperationBind
